export default function PPAModalDescriptionText() {
  return (
    <p>
      With just a few data points, Conductor Solar can provide you with an estimated
      PPA rate for your projects. If the pricing looks good, you can click &apos;Save this pricing&apos;
      and convert your quote into a project to work with potential investors.
    </p>
  );
}